export default __webpack_public_path__ + "static/media/postcode-api-blue.0e10ab81.svg";